import mutations from './myReservations.mutations'
import actions from './myReservations.actions'
import getters from './myReservations.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
